document.addEventListener("DOMContentLoaded", function () {
  const sideDrawer = document.getElementById("SideDrawer");
  const overlay = document.getElementById("SideDrawer-Overlay");
  const openButton = document.getElementById("sideDrawerBtn");
  const closeButton = document.getElementById("close-drawer");

  if (sideDrawer && overlay && openButton && closeButton) {
    // Set initial styles
    sideDrawer.style.display = "none";
    overlay.style.display = "none";

    openButton.addEventListener("click", function () {
      sideDrawer.style.display = "block";
      overlay.style.display = "block";

      // Scroll to the top of the PDP
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      // Add class to body
      document.body.classList.add("overflow-hidden-tablet");

      // Delay the transition by 0.1 seconds
      setTimeout(() => {
        sideDrawer.style.transition = "right 0.2s ease-in-out";
        sideDrawer.style.right = "0";
        overlay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
      }, 100);
    });

    function closeDrawer() {
      sideDrawer.style.transition = "right 0.2s ease-in-out";
      sideDrawer.style.right = "-500px";
      overlay.style.backgroundColor = "rgba(0, 0, 0, 0)";

      // Remove class from body
      document.body.classList.remove("overflow-hidden-tablet");

      // Delay setting display to 'none' until after the transition
      setTimeout(() => {
        sideDrawer.style.display = "none";
        overlay.style.display = "none";
      }, 200); // 200ms, same as transition duration
    }

    overlay.addEventListener("click", closeDrawer);
    closeButton.addEventListener("click", closeDrawer);

    // Update position based on screen width
    function updatePosition() {
      if (window.innerWidth <= 500) {
        sideDrawer.style.width = "100vw";
        sideDrawer.style.height = "100vh";
        sideDrawer.style.position = "fixed";
      } else {
        sideDrawer.style.width = "500px";
        sideDrawer.style.height = "100vh";
      }
    }

    // Call the function on page load and window resize
    updatePosition();
    window.addEventListener("resize", updatePosition);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const sideDrawerTwo = document.getElementById("SideDrawer2");
  const overlayTwo = document.getElementById("SideDrawer-Overlay");
  const openButtonTwo = document.getElementById("sideDrawerBtn2");
  const closeButtonTwo = document.getElementById("close-drawer2");

  if (sideDrawerTwo && overlayTwo && openButtonTwo && closeButtonTwo) {
    // Set initial styles
    sideDrawerTwo.style.display = "none";
    overlayTwo.style.display = "none";

    openButtonTwo.addEventListener("click", function () {
      sideDrawerTwo.style.display = "block";
      overlayTwo.style.display = "block";

      // Scroll to the top of the PDP
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      // Add class to body
      document.body.classList.add("overflow-hidden-tablet");

      // Delay the transition by 0.1 seconds
      setTimeout(() => {
        sideDrawerTwo.style.transition = "right 0.2s ease-in-out";
        sideDrawerTwo.style.right = "0";
        overlayTwo.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
      }, 100);
    });

    function closeDrawerTwo() {
      sideDrawerTwo.style.transition = "right 0.2s ease-in-out";
      sideDrawerTwo.style.right = "-500px";
      overlayTwo.style.backgroundColor = "rgba(0, 0, 0, 0)";

      // Remove class from body
      document.body.classList.remove("overflow-hidden-tablet");

      // Delay setting display to 'none' until after the transition
      setTimeout(() => {
        sideDrawerTwo.style.display = "none";
        overlayTwo.style.display = "none";
      }, 200); // 200ms, same as transition duration
    }

    overlayTwo.addEventListener("click", closeDrawerTwo);
    closeButtonTwo.addEventListener("click", closeDrawerTwo);

    // Update position based on screen width
    function updatePosition() {
      if (window.innerWidth <= 500) {
        sideDrawerTwo.style.width = "100vw";
        sideDrawerTwo.style.height = "100vh";
        sideDrawerTwo.style.position = "fixed";
      } else {
        sideDrawerTwo.style.width = "500px";
        sideDrawerTwo.style.height = "100vh";
      }
    }

    // Call the function on page load and window resize
    updatePosition();
    window.addEventListener("resize", updatePosition);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const sideDrawerThree = document.getElementById("SideDrawer3");
  const overlayThree = document.getElementById("SideDrawer-Overlay");
  const openButtonThree = document.getElementById("sideDrawerBtn3");
  const closeButtonThree = document.getElementById("close-drawer3");

  if (sideDrawerThree && overlayThree && openButtonThree && closeButtonThree) {
    // Set initial styles
    sideDrawerThree.style.display = "none";
    overlayThree.style.display = "none";

    openButtonThree.addEventListener("click", function () {
      sideDrawerThree.style.display = "block";
      overlayThree.style.display = "block";

      // Scroll to the top of the PDP
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      // Add class to body
      document.body.classList.add("overflow-hidden-tablet");

      // Delay the transition by 0.1 seconds
      setTimeout(() => {
        sideDrawerThree.style.transition = "right 0.2s ease-in-out";
        sideDrawerThree.style.right = "0";
        overlayThree.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
      }, 100);
    });

    function closeDrawerThree() {
      sideDrawerThree.style.transition = "right 0.2s ease-in-out";
      sideDrawerThree.style.right = "-500px";
      overlayThree.style.backgroundColor = "rgba(0, 0, 0, 0)";

      // Remove class from body
      document.body.classList.remove("overflow-hidden-tablet");

      // Delay setting display to 'none' until after the transition
      setTimeout(() => {
        sideDrawerThree.style.display = "none";
        overlayThree.style.display = "none";
      }, 200); // 200ms, same as transition duration
    }

    overlayThree.addEventListener("click", closeDrawerThree);
    closeButtonThree.addEventListener("click", closeDrawerThree);

    // Update position based on screen width
    function updatePosition() {
      if (window.innerWidth <= 500) {
        sideDrawerThree.style.width = "100vw";
        sideDrawerThree.style.height = "100vh";
        sideDrawerThree.style.position = "fixed";
      } else {
        sideDrawerThree.style.width = "500px";
        sideDrawerThree.style.height = "100vh";
      }
    }

    // Call the function on page load and window resize
    updatePosition();
    window.addEventListener("resize", updatePosition);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const sideDrawerFour = document.getElementById("SideDrawer4");
  const overlayFour = document.getElementById("SideDrawer-Overlay");
  const openButtonFour = document.getElementById("sideDrawerBtn4");
  const closeButtonFour = document.getElementById("close-drawer4");

  // Ensure all required elements are found before proceeding
  if (sideDrawerFour && overlayFour && openButtonFour && closeButtonFour) {
    // Set initial styles
    sideDrawerFour.style.display = "none";
    overlayFour.style.display = "none";

    openButtonFour.addEventListener("click", function () {
      sideDrawerFour.style.display = "block";
      overlayFour.style.display = "block";

      // Scroll to the top of the PDP
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      // Add class to body
      document.body.classList.add("overflow-hidden-tablet");

      // Delay the transition by 0.1 seconds
      setTimeout(() => {
        sideDrawerFour.style.transition = "right 0.2s ease-in-out";
        sideDrawerFour.style.right = "0";
        overlayFour.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
      }, 100);
    });

    function closeDrawerFour() {
      sideDrawerFour.style.transition = "right 0.2s ease-in-out";
      sideDrawerFour.style.right = "-500px";
      overlayFour.style.backgroundColor = "rgba(0, 0, 0, 0)";

      // Remove class from body
      document.body.classList.remove("overflow-hidden-tablet");

      // Delay setting display to 'none' until after the transition
      setTimeout(() => {
        sideDrawerFour.style.display = "none";
        overlayFour.style.display = "none";
      }, 200); // 200ms, same as transition duration
    }

    overlayFour.addEventListener("click", closeDrawerFour);
    closeButtonFour.addEventListener("click", closeDrawerFour);

    // Update position based on screen width
    function updatePosition() {
      if (window.innerWidth <= 500) {
        sideDrawerFour.style.width = "100vw";
        sideDrawerFour.style.height = "100vh";
        sideDrawerFour.style.position = "fixed";
      } else {
        sideDrawerFour.style.width = "500px";
        sideDrawerFour.style.height = "100vh";
      }
    }

    // Call the function on page load and window resize
    updatePosition();
    window.addEventListener("resize", updatePosition);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const sideDrawerFive = document.getElementById("SideDrawer5");
  const overlayFive = document.getElementById("SideDrawer-Overlay");
  const openButtonFive = document.getElementById("sideDrawerBtn5");
  const closeButtonFive = document.getElementById("close-drawer5");

  if (sideDrawerFive && overlayFive && openButtonFive && closeButtonFive) {
    // Set initial styles
    sideDrawerFive.style.display = "none";
    overlayFive.style.display = "none";

    openButtonFive.addEventListener("click", function () {
      sideDrawerFive.style.display = "block";
      overlayFive.style.display = "block";

      // Scroll to the top of the PDP
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      // Add class to body
      document.body.classList.add("overflow-hidden-tablet");

      // Delay the transition by 0.1 seconds
      setTimeout(() => {
        sideDrawerFive.style.transition = "right 0.2s ease-in-out";
        sideDrawerFive.style.right = "0";
        overlayFive.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
      }, 100);
    });

    function closeDrawerFive() {
      sideDrawerFive.style.transition = "right 0.2s ease-in-out";
      sideDrawerFive.style.right = "-500px";
      overlayFive.style.backgroundColor = "rgba(0, 0, 0, 0)";

      // Remove class from body
      document.body.classList.remove("overflow-hidden-tablet");

      // Delay setting display to 'none' until after the transition
      setTimeout(() => {
        sideDrawerFive.style.display = "none";
        overlayFive.style.display = "none";
      }, 200); // 200ms, same as transition duration
    }

    overlayFive.addEventListener("click", closeDrawerFive);
    closeButtonFive.addEventListener("click", closeDrawerFive);

    // Update position based on screen width
    function updatePosition() {
      if (window.innerWidth <= 500) {
        sideDrawerFive.style.width = "100vw";
        sideDrawerFive.style.height = "100vh";
        sideDrawerFive.style.position = "fixed";
      } else {
        sideDrawerFive.style.width = "500px";
        sideDrawerFive.style.height = "100vh";
      }
    }

    // Call the function on page load and window resize
    updatePosition();
    window.addEventListener("resize", updatePosition);
  }
});
